import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useToastsDispatch } from '@bechtel/gds';
export const TOAST_ID_SELECT_FOREMAN = 'SelectForeman';
export const TOAST_ID_WORK_PACKAGE = 'WorkPackageOutsideWLA';
export const TOAST_ID_NEW_CREW_CHANGE_REQUEST = 'NewCrewChangeRequest';
export const TOAST_ID_NEW_ROD_REQUEST = 'NewRodRequest';

export const ClearToast: FC = () => {
  const location = useLocation();
  const dispatchToast = useToastsDispatch();

  useEffect(() => {
    const pathname = location.pathname;
    if (pathname && !pathname.includes('/planning')) {
      dispatchToast({ type: 'REMOVE_TOAST', payload: { id: TOAST_ID_SELECT_FOREMAN } });
      dispatchToast({ type: 'REMOVE_TOAST', payload: { id: TOAST_ID_WORK_PACKAGE } });
    }
    if (pathname && !pathname.includes('/crew-change'))
      dispatchToast({ type: 'REMOVE_TOAST', payload: { id: TOAST_ID_NEW_CREW_CHANGE_REQUEST } });
    if (pathname && !pathname.includes('/rod-room'))
      dispatchToast({ type: 'REMOVE_TOAST', payload: { id: TOAST_ID_NEW_ROD_REQUEST } });
  }, [location, dispatchToast]);

  return null;
};
